import {
  DriverLicense as CoreDriverLicense,
  type DriverLicenseProps,
} from "@apac/travelers";
import { useI18nContext } from "@hopper-b2b/i18n";

export const DriverLicense = (props: DriverLicenseProps) => {
  const { t } = useI18nContext();

  // Default field overrides for standalone car bookings (required fields)
  const defaultFieldOverrides = {
    address: {
      label: `${t(
        "checkout.travelerInformation.travelerForm.driverLicense.address"
      )}*`,
      placeholder: t(
        "checkout.travelerInformation.travelerForm.driverLicense.addressPlaceholder"
      ),
      required: true,
    },
    issuingCity: {
      label: `${t(
        "checkout.travelerInformation.travelerForm.driverLicense.city"
      )}*`,
      placeholder: t(
        "checkout.travelerInformation.travelerForm.driverLicense.city"
      ),
      required: true,
    },
    issuingCountry: {
      label: `${t(
        "checkout.travelerInformation.travelerForm.driverLicense.country"
      )}*`,
      placeholder: t("choose"),
    },
    postalCode: {
      label: `${t(
        "checkout.travelerInformation.travelerForm.driverLicense.zipCode"
      )}*`,
      placeholder: t(
        "checkout.travelerInformation.travelerForm.driverLicense.zipCodePlaceholder"
      ),
      required: true,
    },
  };

  // Merge incoming fieldOverrides with defaults (incoming takes precedence)
  const mergedFieldOverrides = {
    address: {
      ...defaultFieldOverrides.address,
      ...props.fieldOverrides?.address,
    },
    issuingCity: {
      ...defaultFieldOverrides.issuingCity,
      ...props.fieldOverrides?.issuingCity,
    },
    issuingCountry: {
      ...defaultFieldOverrides.issuingCountry,
      ...props.fieldOverrides?.issuingCountry,
    },
    postalCode: {
      ...defaultFieldOverrides.postalCode,
      ...props.fieldOverrides?.postalCode,
    },
  };

  return (
    <CoreDriverLicense
      {...props}
      showAddress
      showCity
      fieldOverrides={mergedFieldOverrides}
    />
  );
};
